<script>
import { mapActions } from 'vuex';
import Loader from './Common/Loader';
import VInput from './Common/VInput';
import Validate from '../../plugins/Validate';

export default {
  name: 'FormCarPriceSubscription',
  components: {
    VInput,
    Loader
  },
  props: {
    carId: {
      type: Number,
      required: true
    },
    carType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      email: null,
      emailError: null,
      isFormSending: false
    }
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      send: 'FormData/send',
    }),
    async onFormSubmit(){
      if (this.isFormSending) {
        return;
      }

      this.emailError = null;

      if (!Validate.email(this.email)) {
        this.emailError = true;
      }
      
      const formData = {
        action: 'carSubscription',
        email: this.email,
        carId: this.carId,
        carType: this.carType
      };
      
      this.isFormSending = true;
      await this.send(formData);
      this.isFormSending = false;
      this.togglePopup('popup-message');
    }
  }
}
</script>
<template>
  <div class="mb-12 bg-blue-lighten p-[32px]">
    <div class="max-w-[350px] mb-12">
      <h2 class="text-gray-800 text-2xl font-medium mb-3">Хотите отслеживать<br/> изменение цены на&nbsp;этот авто?</h2>
      <p class="text-black-100">Оставьте вашу почту</p>
    </div>
    <form class="flex flex-wrap gap-5" @submit.prevent="onFormSubmit">
      <div class="w-full xl:w-auto xl:min-w-[260px]">
        <v-input
            v-model="email"
            placeholder="E-mail"
            theme="white"
            name="e-mail"
            classesInput="py-[15px]"
            :disabled="isFormSending"
            :error="emailError"
            @update:modelValue="emailError = null"
          />
      </div>
      <button
        type="submit"
        :disabled="isFormSending"
        class="button relative h-[51px] min-w-[185px] block w-full xl:w-auto px-12 text-white border-green bg-green"
        :class="{
          'hover:text-gray-600 hover:border-white hover:bg-white': !isFormSending
        }"
      >
        <loader
          v-if="isFormSending" 
          drop-margins
          remove-bg
          color="white"
          size="s" />
        <template v-else>Подписаться</template>
      </button>
    </form>
  </div>
</template>